<script setup lang="ts">
const { t } = useI18n();

const props = withDefaults(
  defineProps<{
    breadcrumbs?: any;
  }>(),
  {
    breadcrumbs: [],
  }
);
let { breadcrumbs: initialBreadcrumbs } = useBreadcrumbs();
const breadcrumbs = computed(() =>
  props.breadcrumbs?.length > 0 ? props.breadcrumbs : initialBreadcrumbs.value
);

const localePath = useLocalePath();
const { formatLink } = useInternationalization(localePath);

const unifiedBreadcrumbs = computed(() => {
  const homeBreadcrumb = {
    name: t("home"),
    path: "/",
  };

  return breadcrumbs.value && breadcrumbs.value.length > 0
    ? [homeBreadcrumb, ...breadcrumbs.value]
    : breadcrumbs.value;
});

useBreadCrumbsJsonLD(unifiedBreadcrumbs.value);

const isBreadcrumbs = computed(() => breadcrumbs.value?.length > 0);
</script>
<template>
  <div v-if="isBreadcrumbs" class="breadcrumb px-4">
    <div class="container mx-auto relative py-4">
      <div class="wrap">
        <ul class="flex gap-x-2 flex-wrap text-medium-grey">
          <li
            v-for="(breadcrumb, index) in unifiedBreadcrumbs"
            :key="breadcrumb.path"
            class="relative h-[24px] mr-3"
          >
            <template v-if="breadcrumb.path">
              <NuxtLink
                v-if="breadcrumb.path"
                class="text-medium-grey text-nowrap overflow-hidden text-xs font-bold hover:text-red-bg"
                :to="formatLink(breadcrumb.path)"
              >
                {{ breadcrumb.name }}
              </NuxtLink>
              <span
                v-if="index !== breadcrumbs.length"
                class="absolute right-[-15px] top-[5px] text-sm"
                ><i class="fa-solid fa-angle-right"></i
              ></span>
            </template>
            <template v-else>
              <div class="flex items-center relative mt-[6px]">
                <span
                  class="max-w-[80px] truncate md:max-w-[200px] block h-[16px]"
                  :class="[
                    'text-xs font-bold cursor-not-allowed',
                    index === breadcrumbs.length
                      ? 'text-dark-bg cursor-not-allowed'
                      : 'text-medium-grey',
                  ]"
                >
                  {{ breadcrumb.name }}
                </span>
                <span
                  v-if="index !== breadcrumbs.length"
                  class="absolute right-[-15px] -top-[2px] text-sm h-[16px]"
                  ><i class="fa-solid fa-angle-right"></i
                ></span>
              </div>
            </template>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>
